'use strict';

const config = {
  appEnv: 'test',
  apiUrl: 'https://graphql-stage.set.tv/graphql',
  authApiUrl: 'https://access-stage.conversantmedia.com/be/auth/auth',
  loginOptions: {
    validationUrl: 'https://access-stage.conversantmedia.com',
    ssoPage: '/auth/sso.html',
    loginPage: '/auth/login',
    params: {
      product: 'ccui'
    },
    stage: true
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/config/test.js